import {
  getTaxPaymentInternalDeadline,
  getTaxPaymentIRSDeadline,
  Quarter
} from "@wingspanhq/utils/dist/date/taxDeadlines";

type SelectorOptions = {
  quarter?: string;
  year?: string;
  currentDate?: Date;
};

/** Returns whether a scheduled tax payment is still before its cancellation cutoff. */
export const selectorIsScheduledTaxPaymentCancellable = ({
  quarter,
  year,
  currentDate = new Date(Date.now())
}: SelectorOptions): boolean => {
  if (!Object.values(Quarter).includes(quarter as Quarter)) {
    return false;
  }

  const numericYear = Number(year);
  if (!Number.isInteger(numericYear) || numericYear <= 0) {
    return false;
  }

  const internalDeadline = getTaxPaymentInternalDeadline(
    getTaxPaymentIRSDeadline(quarter as Quarter, numericYear)
  );

  return currentDate.getTime() <= internalDeadline.getTime();
};
